<style scoped lang="scss" type="text/scss">
    .left-panel-container {

    }
</style>

<template>
    <card class="left-panel-container">
        <complex-square-info-block
                v-for="(item, index) in items" :key="index"
                @click.native="redirect(item.route_name)"
                :active="currentRouteName === item.route_name" :icon="item.icon" :title="item.title">
            {{ item.description }}
        </complex-square-info-block>
    </card>
</template>

<script>
    import Card from '../../../../components/card/index';
    import ComplexSquareInfoBlock from '../../../../components/square-info-block/complex';
    import ROUTE_NAME from '../../../../router/names';

    export default {
        name: '',
        components: {
            Card,
            ComplexSquareInfoBlock
        },
        data () {
            return {
                items: [
                    {
                        title: '进度概览',
                        icon: '&#xe618;',
                        description: '查看整体填报情况',
                        route_name: ROUTE_NAME.PLAYER.CONFIRM_OVERVIEW
                    },
                    {
                        title: '填报详情',
                        icon: '&#xe60c;',
                        description: '查看已填报的内容：参赛人员、人员推荐等',
                        route_name: ROUTE_NAME.PLAYER.CONFIRM_DETAIL
                    },
                    {
                        title: '参赛确认',
                        icon: '&#xe60e;',
                        description: '最终确认',
                        route_name: ROUTE_NAME.PLAYER.CONFIRM_CONFIRM
                    }
                ]
            };
        },
        computed: {
            currentRouteName () {
                return this.$route.name;
            }
        },
        methods: {
            redirect (routeName) {
                this.$router.push({
                    name: routeName
                });
            }
        }
    };
</script>
